require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-9-exciting-new-social-media-features-and-updates-in-2018.json") })
        }
      }, "path---tapd-in-9-exciting-new-social-media-features-and-updates-in-2018");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-9-exciting-new-social-media-features-and-updates-in-2018!./.cache/json/tapd-in-9-exciting-new-social-media-features-and-updates-in-2018.json
// module id = 808
// module chunks = 231608221292675